import { gql } from '@apollo/client';

export const ADD_UPDATE_FINANCIAL_INDICATOR = gql`
  mutation addOrUpdateFinancialIndicator($input: FinancialIndicatorItemInput) {
    addOrUpdateFinancialIndicator(input: $input) {
      commandId
    }
  }
`;
